import * as Hyphenopoly from 'hyphenopoly';

/**
 * Contains methods for manually executing Hyphenopoly-hyphenation.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class HyphenopolyUtility {
  /**
   * Hyphenates all elements defined by the selector within the given element.
   *
   * @param {HTMLElement} container Container
   * @param {string} [selector] Elements within the container which should be hyphenated (defaults to ".hyphenate")
   * @returns {void}
   */
  static hyphenate(container: HTMLElement, selector: string = '.hyphenate'): void {
    Hyphenopoly.hyphenators.HTML.then((hyn: any) => {
      container.querySelectorAll(selector).forEach(element => {
        hyn(element);
      });
    });
  }
}
